import { relacao_de_alunos_com_matriculas_canceladas } from "./relacao-de-alunos-com-matriculas-canceladas";
import { relacao_de_alunos_sem_certidao_de_nascimento } from "./relacao-de-alunos-sem-certidao-de-nascimento";

const relatorios = [
  ...relacao_de_alunos_com_matriculas_canceladas,
  ...relacao_de_alunos_sem_certidao_de_nascimento,
];

export { relatorios };
